export const AVA_FAQ_ENTRY_POINT_IMPRESSION = {
    url: '/trk/video_player_ava:faq_entry_point_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const AVA_FAQ_ENTRY_POINT_CLICK = {
    url: '/trk/video_player_ava:faq_entry_point_click',
    isUserEngagement: true,
    consent: 'essential',
};
export const AVA_INPUT_ENTRY_POINT_SUBMIT = {
    url: '/trk/video_player_ava:input_entry_point_submit',
    isUserEngagement: true,
    consent: 'essential',
};
